// extracted by mini-css-extract-plugin
export default {"main":"CorpusLabel_main__dWEPv","dracor-id":"CorpusLabel_dracor-id__gtGDv"};